import baseConfig from "../baseconfig.json"; 

export function shouldShowComponent(domain, componentName) {
  return baseConfig.displayDomains[domain]?.includes(componentName);
}